module.exports = __webpack_public_path__ + "img/logo-sm.3bb9d622.png";